import React from 'react';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    initials: 'MG',
    text: 'Después de los 40 sentía que mi cuerpo ya no me respondía. En 3 semanas bajé la hinchazón, dormí mejor y por fin entendí por qué no bajaba de peso.',
    author: 'María G., Córdoba',
    role: 'Super Combo'
  }, {
    initials: 'LP',
    text: 'El plan de 21 días con comida argentina real fue un antes y un después. Sin pasar hambre, sin buscar ingredientes raros, sin complicarme.',
    author: 'Laura P., Rosario',
    role: 'Super Combo'
  }, {
    initials: 'RM',
    text: 'Tenía la barriga dura hace años y no entendía por qué. El Tomo 1 me explicó todo. El cortisol era mi problema. Ahora sé exactamente qué hacer.',
    author: 'Roberto M., Buenos Aires',
    role: 'Super Combo'
  }];
  return <section className="bg-black text-white py-20 px-4" data-id="element-335">
      <div className="max-w-5xl mx-auto" data-id="element-336">
        <h2 className="font-display font-black text-4xl md:text-5xl text-center mb-12 uppercase" data-id="element-337">
          Lo que dicen quienes <span className="text-brand" data-id="element-338">ya lo usan</span>
        </h2>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-339">
          {testimonials.map((t, i) => <div key={i} className="bg-zinc-900 border border-zinc-800 p-8 rounded-xl flex flex-col h-full hover:border-brand/50 transition-colors" data-id="element-340">
              <div className="flex items-center justify-between mb-6" data-id="element-341">
                <div className="w-12 h-12 bg-brand/20 text-brand rounded-full flex items-center justify-center font-bold text-xl" data-id="element-342">
                  {t.initials}
                </div>
                <div className="flex text-brand" data-id="element-343">
                  {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-current" data-id="element-344" />)}
                </div>
              </div>
              <p className="text-lg italic text-gray-300 mb-6 flex-grow" data-id="element-345">
                "{t.text}"
              </p>
              <div data-id="element-346">
                <div className="font-bold text-white" data-id="element-347">{t.author}</div>
                <div className="text-brand text-sm font-medium" data-id="element-348">{t.role}</div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}